(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) {
    root.BoGalleryLazy = api;
    api.install(root);
  }
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';

  function activateImage(image) {
    if (!image || !image.dataset || !image.dataset.src) return false;
    image.setAttribute('src', image.dataset.src);
    if (image.dataset.srcset) image.setAttribute('srcset', image.dataset.srcset);
    image.removeAttribute('data-src');
    image.removeAttribute('data-srcset');
    return true;
  }

  function activatePoster(media) {
    if (!media || !media.dataset || !media.dataset.poster) return false;
    media.setAttribute('poster', media.dataset.poster);
    media.removeAttribute('data-poster');
    return true;
  }

  function activateSlide(slide) {
    if (!slide || typeof slide.querySelector !== 'function') return false;
    var imageActivated = activateImage(slide.querySelector('img[data-src]'));
    var posterActivated = activatePoster(slide.querySelector('video[data-poster]'));
    return imageActivated || posterActivated;
  }

  function install(root) {
    if (!root || !root.document || typeof root.document.querySelectorAll !== 'function') return false;
    var media = Array.prototype.slice.call(root.document.querySelectorAll('video[data-poster]'));
    if (!media.length) return false;
    if (typeof root.IntersectionObserver !== 'function') {
      media.forEach(activatePoster);
      return true;
    }
    var observer = new root.IntersectionObserver(function (entries, activeObserver) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        activatePoster(entry.target);
        if (activeObserver && typeof activeObserver.unobserve === 'function') activeObserver.unobserve(entry.target);
      });
    }, { rootMargin: '600px 0px' });
    media.forEach(function (item) { observer.observe(item); });
    return true;
  }

  return { activateImage: activateImage, activatePoster: activatePoster, activateSlide: activateSlide, install: install };
});
